import Hero from "../components/Hero";
// import Header from "../components/Navbar"
import SearchResult from "../components/SearchResult";
import { SimpleFooter } from "../components/Fotter";
import { useState } from "react";
import { RecepiesContext } from "../context/RepiesContext";
const Main = () => {
    const [recepies, setRecepies] = useState([]);

    return (
        <RecepiesContext.Provider value={{ recepies, setRecepies }}>
            <Hero />
            <SearchResult />
            <SimpleFooter />
        </RecepiesContext.Provider>)
}
export default Main;